import { makeStyles } from "@material-ui/core";
import { colors } from "../../../../../../../shared/utils";

const useStyles = makeStyles({
  // Contenedor único: el Paper de formsSection es una columna flex con
  // justify-content space-between; sin este wrapper el título y la tabla
  // quedan como hijos flex separados y se abren verticalmente.
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    rowGap: "8px",
    width: "100%",
  },
  headerComponent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "24px",
  },
  title: {
    color: colors.blueDarken,
  },
  tableWrapper: {
    borderRadius: "19px",
    overflow: "hidden",
    border: `1px solid ${colors.whiteDark}`,
    minWidth: "500px",
    width: "100%",
    boxSizing: "border-box",
  },
  table: {
    tableLayout: "fixed",
    width: "100%",
  },
  headerCell: {
    background: colors.blueLighten,
    color: colors.white,
    fontWeight: 600,
    borderBottom: "none",
  },
  cell: {
    color: colors.greyFont,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  summaryRow: {
    background: colors.disabledSoft,
  },
  summaryLabel: {
    color: colors.greyFont,
    fontWeight: 600,
  },
  emptyState: {
    color: colors.greyFont,
    padding: "16px 0",
  },
});

export default useStyles;
